import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api, { Lane } from '../lib/api'

export default function LanesPage() {
  const [items, setItems] = useState<Lane[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [q, setQ] = useState('')

  const load = async (query?: string) => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.lanes.list({ q: query || undefined, status: 'ACTIVE' })
      setItems(res.data)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to load lanes')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Shipping Lanes</h1>
        <Link to="/lanes/new" className="px-3 py-2 rounded bg-blue-700 text-white text-sm">New Lane</Link>
      </div>

      <form
        className="flex gap-2"
        onSubmit={(e) => {
          e.preventDefault()
          void load(q)
        }}
      >
        <input className="border rounded px-3 py-2 text-sm w-full" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search lane #, customer, route..." />
        <button className="border rounded px-3 py-2 text-sm">Search</button>
      </form>

      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      {loading ? <div className="text-sm text-gray-500">Loading lanes...</div> : null}
      {!loading && !items.length ? <div className="text-sm text-gray-500">No lanes found.</div> : null}

      <div className="bg-white border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-3 py-2">Lane #</th>
              <th className="px-3 py-2">Customer</th>
              <th className="px-3 py-2">Route</th>
              <th className="px-3 py-2">Miles</th>
              <th className="px-3 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((lane) => (
              <tr key={lane.id} className="border-t">
                <td className="px-3 py-2">
                  <Link className="text-blue-700" to={`/lanes/${lane.id}`}>{lane.laneNumber}</Link>
                </td>
                <td className="px-3 py-2">{lane.customerName ?? '-'}</td>
                <td className="px-3 py-2">
                  {[lane.originCity, lane.originState, lane.originZip].filter(Boolean).join(', ')}
                  {' -> '}
                  {[lane.destinationCity, lane.destinationState, lane.destinationZip].filter(Boolean).join(', ')}
                </td>
                <td className="px-3 py-2">{lane.estDistanceMiles ?? '-'}</td>
                <td className="px-3 py-2">{lane.status ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
